var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "cascader" },
    [
      _vm.isBol
        ? _c(
            "area-cascader",
            _vm._g(
              _vm._b(
                {
                  ref: "cascader",
                  attrs: { type: "text", data: _vm.dataList },
                },
                "area-cascader",
                _vm.$attrs,
                false
              ),
              _vm.$listeners
            )
          )
        : _vm._e(),
      _c("i", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.$attrs.value.length,
            expression: "$attrs.value.length",
          },
        ],
        staticClass: "el-icon-error closeIcon",
        on: { click: _vm.handleClose },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }